import React, { useEffect } from 'react';

/**
 * Layout condiviso per le pagine di contenuto (Dashboard, Atleti, Archivio, Profilo).
 * Gestisce: body page-scrollable, sfondo, header sticky, area contenuto centrata.
 *
 * @param {ReactNode} header   — contenuto della barra sticky in alto
 * @param {ReactNode} children — contenuto della pagina (va nel div centrato)
 * @param {number}    maxWidth — larghezza massima del contenuto (default 1100px)
 * @param {string}    padding  — padding del contenuto (default '28px 20px')
 */
function PageLayout({ header, children, maxWidth = 1100, padding = '28px 20px' }) {
  useEffect(() => {
    document.body.classList.add('page-scrollable');
    return () => document.body.classList.remove('page-scrollable');
  }, []);

  return (
    <div
      className="page-scrollable"
      style={{
        background:  'var(--bg-primary)',
        minHeight:   '100vh',
        color:       'var(--color-text)',
        fontFamily:  'inherit',
      }}
    >
      {header && (
        <header style={{
          display:        'flex',
          alignItems:     'center',
          justifyContent: 'space-between',
          padding:        '0 28px',
          height:         56,
          background:     'var(--bg-secondary)',
          borderBottom:   '1px solid var(--color-border)',
          position:       'sticky',
          top:            0,
          zIndex:         'var(--z-sticky)',
        }}>
          {header}
        </header>
      )}

      <div style={{ maxWidth, margin: '0 auto', padding }}>
        {children}
      </div>
    </div>
  );
}

export default PageLayout;
